import React from 'react'
import { Navigate, Route, Routes } from "react-router-dom"
//layer
import Slide from '../layer/slide'
// page
import Login from '../page/login'
import Register from '../page/register'
import Products from '../page/products'
import BuyProduct from '../page/buyProduct'
import Home from '../page/home'
import LogOut from '../page/logout'
import Service from '../page/service'
import ContactUs from '../page/contactUs'
import AboutUs from '../page/aboutUs'
import Aside from '../component/aside'
import TestC from '../page/testC'
//third party
import { useSelector, useDispatch } from 'react-redux'
import Footer from '../component/footer'
import Header from '../component/header'
import Teammate from '../page/teammate'
import Journals from '../page/journals'
import Journal from '../page/journal'
import Conferences from '../page/conferences'
import Conference from '../page/conference'
import Books from '../page/books'
import Book from '../page/book'
import Webinars from '../page/webinars'
import Webinar from '../page/webinar'
import RegisterWebinar from '../page/buy/registerWebinar'
import Files from '../page/files'
import File from '../page/file'
import BuyWebinar from '../page/buy/buyWebinar'
import AfterBuy from '../page/buy/afterBuy'
import { isEmptyUser } from '../utils/isEmpty'
import MyWebinars from '../page/dashboard/myWebinars/myWebinars'
import CompleteInformations from '../page/dashboard/completeInformations/completeInformations'
import MyFiles from '../page/dashboard/myFiles/myFiles'
import ChangePassword from '../page/dashboard/changePassword/changePassword'

import Dashboard from "../page/dashboard/dashboard"
import CTest from '../page/dashboard/cTest/cTest'
import ChanceRound from '../page/chanceRound'
import ETest from '../page/dashboard/eTest/eTest'
import TestE from '../page/testE'
import Chance from '../page/chance'


const MainLayout = () => {

    const user = useSelector((state) => state.user)
    const asideState = useSelector((state) => state.aside)
    return (

        <>
            {/* ===================== header */}
            <Chance />
            <Header />

            {/* ===================== main */}





            <Routes>
                <Route exact index element={<Home />} />
                <Route exact path='login' element={<Login />} />
                <Route exact path='register' element={<Register />} />
                <Route exact path='logOut' element={<LogOut />} />
                <Route exact path='service' element={<Service />} />
                <Route exact path='contactUs' element={<ContactUs />} />
                <Route exact path='aboutUs' element={<AboutUs />} />
                <Route exact path='teammate' element={<Teammate />} />

                <Route path="journals" >
                    <Route index element={<Journals />} />
                    <Route path=":slug" element={<Journal />} />
                    {/* <Route path="*" element={<NotFound />} /> */}
                </Route>
                <Route path="conferences" >
                    <Route index element={<Conferences />} />
                    <Route path=":slug" element={<Conference />} />
                    {/* <Route path="*" element={<NotFound />} /> */}
                </Route>

                <Route path="books" >
                    <Route index element={<Books />} />
                    <Route path=":slug" element={<Book />} />
                    {/* <Route path="*" element={<NotFound />} /> */}
                </Route>

                <Route path="webinars" >
                    <Route index element={<Webinars />} />
                    <Route path=":slug" element={<Webinar />} />
                    {/* <Route path="*" element={<NotFound />} /> */}
                </Route>
                <Route path="files" >
                    <Route index element={<Files />} />
                    <Route path=":slug" element={<File />} />
                    {/* <Route path="*" element={<NotFound />} /> */}
                </Route>


                <Route path="registerWebinar" >
                    <Route path=":slug" element={<RegisterWebinar />} />
                </Route>
                <Route path="buyWebinar" >
                    <Route path=":slug" element={<BuyWebinar />} />
                </Route>
                <Route path="afterBuy" >
                    <Route path=':state' element={<AfterBuy />} />
                </Route>

                <Route path="dashboard" >
                    {
                        isEmptyUser(user.value) ?
                            (

                                <Route index element={<Navigate to="/" replace />} />
                            ) :
                            (
                                <>
                                    <Route index element={<Dashboard ><CompleteInformations /></Dashboard>} />
                                    <Route path="changePassword" element={<Dashboard ><ChangePassword /></Dashboard>} />
                                    <Route path="myWebinars" element={<Dashboard ><MyWebinars /></Dashboard>} />
                                    <Route path="myFiles" element={<Dashboard ><MyFiles /></Dashboard>} />
                                    <Route path="cTest" element={<Dashboard ><CTest /></Dashboard>} />
                                    <Route path="eTest" element={<Dashboard ><ETest /></Dashboard>} />
                                    <Route path="*" element={<div>no route dash</div>} />
                                </>
                            )
                    }

                </Route>

                <Route path="testC" >
                    <Route path=":username" element={<TestC />} />
                </Route>
                <Route path="testE" >
                    <Route path=":username/:examId" element={<TestE />} />
                </Route>
                <Route path="chanceRound" >
                    <Route path=":username" element={<ChanceRound />} />
                </Route>

                <Route path="products" >
                    <Route index element={<Products />} />
                    <Route path=":address" element={<BuyProduct />} />
                </Route>
                <Route path="*" element={<div>404</div>} />
            </Routes>
            {/* ===================== footer */}
            <Footer />
            {/* ===================== slide */}
            {asideState.value ? (
                <Aside />
            ) : (
                null
            )}

        </>
    )
}


export default MainLayout